import { styled } from "theme/default/styled";

export const SFetchedFilterMultipleSelectSelectContainer = styled.div`
  position: relative;
`;
